<template>
  <fieldset class="gv-format">
    <legend>Video format</legend>
    <p>Match the shape of your original video. For YouTube Shorts or other vertical videos, choose Portrait.</p>
    <div class="gv-format__choices">
      <label v-for="choice in choices" :key="choice.value" :class="{ selected: value === choice.value }">
        <input type="radio" :name="groupName" :value="choice.value" :checked="value === choice.value" @change="$emit('input', choice.value)" />
        <span class="gv-format__shape" :class="{ portrait: choice.value === '9:16' }" aria-hidden="true"></span>
        <span><strong>{{ choice.label }}</strong><small>{{ choice.value }}</small></span>
      </label>
    </div>
    <p class="gv-format__note">The format changes the player frame. It does not crop or rotate your video.</p>
  </fieldset>
</template>
<script>
export default {
  name: 'VideoFormatPicker',
  props: { value: { type: String, default: '16:9' } },
  data() { return { groupName: `video-format-${this._uid}`, choices: [{ value: '16:9', label: 'Landscape' }, { value: '9:16', label: 'Portrait' }] }; },
};
</script>
<style scoped>
.gv-format { min-width: 0; padding: 0; border: 0; margin: 0; }
.gv-format legend { font-weight: 600; font-size: 14px; color: #192336; }
.gv-format p { font-size: 13px; line-height: 1.6; color: #64748b; margin: 6px 0 12px; }
.gv-format__choices { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; }
.gv-format label { display: flex; align-items: center; gap: 12px; padding: 16px 12px; border: 1px solid #dce2ee; border-radius: 12px; cursor: pointer; background: white; margin: 0; }
.gv-format label.selected { background: #f0f5ff; border-color: #3267df; box-shadow: inset 0 0 0 1px #3267df; }
.gv-format input { accent-color: #3267df; flex-shrink: 0; }
.gv-format strong, .gv-format small { display: block; }
.gv-format small { color: #64748b; margin-top: 4px; }
.gv-format__shape { width: 32px; height: 18px; border: 2px solid #657899; border-radius: 3px; flex-shrink: 0; }
.gv-format__shape.portrait { width: 18px; height: 32px; margin: 0 7px; }
@media(max-width: 390px) { .gv-format__choices { grid-template-columns: 1fr; } }
</style>
